"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AppReleaseInjector;
var _react = _interopRequireDefault(require("react"));
var __jsx = _react.default.createElement;
/**
 * Server-side component that injects the app release into the page.
 * Works for both Next.js Page Router and App Router.
 * It's used to make the app release available to the client-side.
 *
 * Gets the App Release from environment variables:
 * - POD_NAME: Kubernetes pod name (format: <app-name>-<replica-set-hash>-<pod-hash>)
 * - LABEL_APP: App name label
 */
function AppReleaseInjector() {
  var _process$env$POD_NAME, _process$env$LABEL_AP;
  var podName = (_process$env$POD_NAME = process.env.POD_NAME) !== null && _process$env$POD_NAME !== void 0 ? _process$env$POD_NAME : '';
  var labelApp = (_process$env$LABEL_AP = process.env.LABEL_APP) !== null && _process$env$LABEL_AP !== void 0 ? _process$env$LABEL_AP : '';
  if (!podName || !podName.startsWith(labelApp) || podName === labelApp) {
    return null;
  }
  var appRelease = podName.split('-').slice(0, -1).join('-');
  return __jsx("script", {
    id: "app-release-data"
    // eslint-disable-next-line react/no-danger
    ,

    dangerouslySetInnerHTML: {
      __html: "window.appRelease = ".concat(JSON.stringify(appRelease), ";")
    }
  });
}